/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useInfoDialog } from 'contexts/InfoDialogContext';
import { getAccountDetails } from 'utils/account-details';
import { IllustrationFreeTrial } from 'components/shared/illustrations/IllustrationFreeTrial';
import { IllustrationRestricted } from 'components/shared/illustrations/IllustrationRestricted';

const WelcomeDialogHandler = () => {
  const { openInfoDialog } = useInfoDialog();
  const accountDetails = getAccountDetails();

  useEffect(() => {
    if (accountDetails?.freeTrialEnd && accountDetails?.sub) {
      const now = new Date();
      const trialEndDate = new Date(accountDetails.freeTrialEnd * 1000);

      const diffInMs = trialEndDate - now;
      const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));

      const localKey = `freeTrialDialogShown_${accountDetails.sub}`;
      const sessionKey = `freeTrialReminderShown_${accountDetails.sub}`;
      const expiredKey = `freeTrialExpiredDialogShown_${accountDetails.sub}`;

      const alreadyShownLocal = localStorage.getItem(localKey);
      const alreadyShownSession = sessionStorage.getItem(sessionKey);
      const alreadyShownExpired = sessionStorage.getItem(expiredKey);

      // const freeTrialEndFormatted = trialEndDate.toLocaleDateString('en-US', {
      //   year: 'numeric',
      //   month: 'long',
      //   day: 'numeric',
      // });

      const showDialog = () => {
        openInfoDialog({
          heading: 'Currently AgentsSpace is free, enjoy!',
          text: `Congratulations on signing up to AgentsSpace!`,
          // text: `Congratulations on signing up to Agents Space!\nYour 14-day free trial starts today and will end on ${freeTrialEndFormatted}.`,
          confirmButtonText: 'Got it',
          illustration: <IllustrationFreeTrial />,
          handler: () => null,
        });
      };

      if (diffInDays < 0 && !alreadyShownExpired && accountDetails?.accountStatus === 'Restricted') {
        // Free trial expired
        openInfoDialog({
          heading: 'Your 14-day free trial has now expired.',
          text: `You no longer have access to the app.\nAdd your billing account to continue using\nAgents Space.`,
          confirmButtonText: 'Got it',
          illustration: <IllustrationRestricted />,
          handler: () => null,
        });
        sessionStorage.setItem(expiredKey, 'true');
        sessionStorage.removeItem(sessionKey);
        localStorage.removeItem(localKey);
      } else if (diffInDays <= 3 && accountDetails?.accountStatus === 'Active') {
        // If trial is expiring in 3 days or less use sessionStorage (every login of in a new tab/session)
        localStorage.removeItem(localKey);

        if (!alreadyShownSession) {
          showDialog();
          sessionStorage.setItem(sessionKey, 'true');
        }
      } else if (diffInDays <= 15 && !alreadyShownLocal && accountDetails?.accountStatus === 'Active') {
        showDialog();
        localStorage.setItem(localKey, 'true');
      } else if (!alreadyShownLocal && accountDetails?.accountStatus === 'Active') {
        // Additional condition to show dialog for every user after login
        showDialog();
        localStorage.setItem(localKey, 'true');
      }
    }
  }, []);

  return null;
};

export default WelcomeDialogHandler;
